import React, { useContext, useEffect, useState } from 'react'
import { t } from 'i18next';
import useWindowSize from '../../customHooks/useWindowSize';
import { EntryAndDepartureTable } from './EntryAndDepartureTable/EntryAndDepartureTable';
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { EntryAndDepartureModal } from './EntryAndDepartureModal';
import { CustomModal } from '../CustomModal/CustomModal';
import errorIcon from '../../assets/icons/triangule-exclamation.svg';
import './entryAndDeparture.css';
import { EntryAndDepartureCardsListMobile } from './EntryAndDepartureMobile/EntryAndDepartureCardsListMobile';
import { EntryAndDepartureTabletFilter } from './EntryAndDepartureTabletFilter';
import useGetDateAndHour from '../../customHooks/useGetDateAndHour';
import EntryAndDepartureFilterHeader from './EntryAndDepartureFilterHeader';
import CustomPagination from '../CustomPagination/CustomPagination';
import { Spinner } from 'reactstrap';

export const EntryAndDeparture = () => {

    const { windowWidth } = useWindowSize();
    const { systemDate, isFetchingSystemDate } = useGetDateAndHour();

    const putCardMobile = windowWidth <= 650;

    const { entryAndDepartureReportState, getEntriesAndDepartures, setEntriesAndDeparturesLoading, cleanErrorMsg } = useContext(EntryAndDepartureReportContext);
    const { filters, isFetching, error, totalPages } = entryAndDepartureReportState;

    const [showDetailModal, setShowDetailModal] = useState(false);

    const [resourceInfo, setResourceInfo] = useState({
        access_resource_id: null,
        resource_type: null,
        status: null
    });

    const handleChangePage = (page) => {
        getEntriesAndDepartures({
            ...filters,
            reg_from: page,
        })
    }

    const closeErrorModal = () => cleanErrorMsg();

    const getEntriesAndDeparturesDefault = () => {
        const haveDates = !!filters.date_from.trim() && !!filters.date_to.trim();
        if (haveDates && isFetchingSystemDate === false) {
            getEntriesAndDepartures(filters);
        } else {
            if (isFetchingSystemDate === false) {
                const filter = {
                    ...filters,
                    date_from: `${systemDate.split(' ')[0]}`,
                    date_to: `${systemDate.split(' ')[0]}`,
                }
                getEntriesAndDepartures(filter);
            }
        }

    }

    useEffect(() => {
        setEntriesAndDeparturesLoading();
        getEntriesAndDeparturesDefault();
        // eslint-disable-next-line
    }, [isFetchingSystemDate])

    return (
        <>
            <EntryAndDepartureModal
                showDetailModal={showDetailModal}
                setShowDetailModal={setShowDetailModal}
                resourceInfo={resourceInfo}
            />

            <CustomModal showModal={error.ok} centered={true} setShowModal={closeErrorModal}>
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img src={errorIcon} alt="" />
                    <p className='mt-3 text-center param-section-title'>{error.text}</p>
                    <p type="button" className='custom-modal-btn-ok' onClick={closeErrorModal}>{t('UNDERSTOOD')}</p>
                </div>
            </CustomModal>


            <div className=' d-flex flex-column justify-content-between ps-4 pe-4 h-100'>
                <div className='mt-4'>
                    <EntryAndDepartureFilterHeader
                        systemDate={systemDate}
                    />
                    <EntryAndDepartureTabletFilter />
                    <div>
                        {
                            isFetching ?
                                <div className='d-flex justify-content-center'>
                                    <Spinner />
                                </div>
                                :

                                putCardMobile ?
                                    <EntryAndDepartureCardsListMobile
                                        setShowDetailModal={setShowDetailModal}
                                        setResourceInfo={setResourceInfo}
                                    />
                                    :
                                    <EntryAndDepartureTable
                                        setShowDetailModal={setShowDetailModal}
                                        setResourceInfo={setResourceInfo}
                                    />
                        }
                    </div>
                </div>
                <div className='d-flex justify-content-center pb-4'>
                    <CustomPagination
                        totalPages={totalPages}
                        page={filters.reg_from}
                        setPage={handleChangePage}
                        disabled={isFetching}
                    />
                </div>
            </div>


        </>
    )
}
